import { Tab } from '@scuf/common';
import { useTranslation } from 'react-i18next';
import 'styles/main.scss';
import 'styles/repaircenter.scss';
import MaintenanceReportSearch from './maintenanceReportSearch';
import MaintenanceReportExport from './maintenanceReportExport';
import useUser from 'helpers/hooks/useUser';
import { USER_MANAGER } from 'resources';
import { useEffect, useState } from 'react';
import useFetch from 'helpers/hooks/useFetch';

const SUPERADMIN = '1';
const ADMIN = '2';

interface ManualFile {
    id: number;
    displayName: string;
    storedFileName: string;
    section: 'MAINTENANCEREPORT';
}

function MaintenanceReportPage() {
    const { t } = useTranslation(['common', 'maintenancereport', 'spareparts']);
    const { user } = useUser();

    const [show, setShow] = useState(false);
    const { user: userDetails, getUser } = useUser();
    const [fileUrl, setFileUrl] = useState<string>();
    const [, fetchFiles] = useFetch<void, ManualFile[]>({
        url: `${USER_MANAGER.getManualFilesBySection}?section=MAINTENANCEREPORT`,
        method: 'GET'
    });

    useEffect(() => {
        if (userDetails && Object.keys(userDetails).length > 0) {
            loadFiles();
        }
    }, [userDetails]);

    const loadFiles = async (): Promise<void> => {
        try {
            await fetchFiles(undefined, resp => {
                const checkList: ManualFile[] = resp?.data ?? [];
                if (checkList.length > 0) {
                    const foundFile = checkList.find(file => file.displayName === 'mensagemreport');
                    if (foundFile) {
                        const url = `${USER_MANAGER.downloadManualFileById}?id=${foundFile.id}`;
                        setFileUrl(url);
                        setShow(true);
                    }
                }
            });
        } catch (error: any) {
            if (error.status === 401) {
                await getUser();
            } else {
                console.error(t('manual.fetchFilesError'));
            }
        }
    };

    return (
        <>
            {show && userDetails && Object.keys(userDetails).length > 0 && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}
                    onClick={() => setShow(false)}
                >
                    <img
                        style={{ maxWidth: '800px', maxHeight: '800px' }}
                        src={fileUrl}
                        onClick={e => e.stopPropagation()}
                        title="Mensagem Portal"
                    />
                </div>
            )}
            <div>
                <div className="container">
                    <Tab defaultActiveIndex={0} className="tab-with-divider">
                        <Tab.Pane title={t('maintenancereport:page_name')}>
                            <MaintenanceReportSearch />
                        </Tab.Pane>
                        {user?.role === SUPERADMIN || user?.role === ADMIN ? (
                            <Tab.Pane title={t('spareparts:tabs.Report')}>
                                <MaintenanceReportExport />
                            </Tab.Pane>
                        ) : (
                            []
                        )}
                    </Tab>
                </div>
            </div>
        </>
    );
}

export default MaintenanceReportPage;
